import React from "react";
import { useSelector } from "react-redux";
import { SITE_CARD_CONFIG } from "../../utils/UnvisitedSiteCardConfig";
import { getUnvistedSiteAnalytic } from "../../utils/siteHelpers";

export const SummaryCard = () => {
  const originalData = useSelector((state) => state.data.data);
  const stats = getUnvistedSiteAnalytic(originalData);

  return (
    <div className="flex gap-4 mt-2">
      {SITE_CARD_CONFIG.map((card, index) => {
        const Icon = card.icon;

        return (
          <div
            key={index}
            className="white-card w-full"
          >
            {/* Icon */}
            <div className={`p-2 rounded-md ${card.bg}`}>
              <Icon className={card.color} />
            </div>

            {/* Content */}
            <div>
              <h3 className={`${card.color} text-xl font-bold`}>
                {stats[card.key]}
              </h3>
              <p className="text-xs font-figtreeMedium text-[#6b7aab]">
                {card.title}
              </p>
              <p className="text-[10px] text-[#6b7aab]">{card.subtitle}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
